import { useEffect, useState } from "react";

interface FormProps {
    submitted: boolean;
    setSubmitted: (submitted: boolean) => any;
}

export function Form(props: FormProps) {

    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        props.setSubmitted(submitted);
    }, [submitted])

    return (
        <div className="blackground">
            <div className='form-container'>
                <div className="banner"></div>
                <form className={"form-style-1"}>
                <ul>
                    <li>
                        <label>Namn <span className="required">*</span></label>
                        <input type="text" />
                    </li>
                    <li>
                        <label>Mejl <span className="required">*</span></label>
                        <input type="email" />
                    </li>
                    <li>
                        <label>Val av mat</label>
                        <select name="diet">
                            <option></option>
                            <option>Tfif korv</option>
                            <option style={{color: "gold"}}>★Macka★</option>
                            <option>Veganese</option>
                        </select>
                    </li>
                    <li>
                        <label>Är du inte DaTe medlem...</label>
                        <input type="radio"/>Ja
                        <input type="radio"/>Nej
                    </li>
                    <li>
                        <label>Jag representerar en förening?<span className="required">*</span></label>
                        <input type="text" />
                    </li>
                </ul>
                </form>
                <div className={"anmal-button"} onClick={e => setSubmitted(true)}>Anmäl</div>
            </div>
        </div>
    )
}
